import { execute, GetDictionaryDocument } from '@/fo/api/magento';
import type { DictionaryOption } from '@/fo/api/magento';

// Тип результата
export type Result<T> = {
  data: T | null;
  error: string | null;
};

/**
 * Получить справочник по коду
 */
export const getDictionary = async (
  identifier: string
): Promise<Result<DictionaryOption[]>> => {
  const result = await execute(GetDictionaryDocument, { identifier });
  if (result.errors?.length) {
    return { data: null, error: result.errors[0].message };
  }
  const dict = result.data?.dictionary?.filter(Boolean) as
    | DictionaryOption[]
    | undefined;
  return { data: dict ?? null, error: null };
};

export const dictionaryService = {
  getDictionary
};
